/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { breakpoints } from '@coursera/cds-core';

type Props = {
  leftImage: string;
  leftPartnerName: string;
  rightImage: string;
  rightPartnerName: string;
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
  `,
  divider: () => css`
    background: var(--cds-color-grey-300);
    height: 32px;
    width: 2px;
    margin: 0 var(--cds-spacing-300);
  `,
  image: () => css`
    max-width: 100%;
    height: 36px;
    ${breakpoints.down('sm')} {
      height: 30px;
    }
  `,
};

const HeroCoBrandingPartnerLogos = ({ leftImage, leftPartnerName, rightImage, rightPartnerName }: Props) => {
  return (
    <div css={styles.container}>
      <Imgix src={leftImage} alt={leftPartnerName} maxHeight={36} css={styles.image} />
      <div css={styles.divider} data-testid="hero-co-branding-divider" />
      <Imgix src={rightImage} alt={rightPartnerName} maxHeight={36} css={styles.image} />
    </div>
  );
};

export default HeroCoBrandingPartnerLogos;
